const state = {
    visitedViews: [],
    cachedViews: [],
    bbb:{"Values":["0.0800","0.0900","0.0800","0.0800","0.0800","0.0800","0.0800","0.0800","0.0800","0.0800","0.0800","0.0800","0.0800","0.0800","0.0900","0.0800","0.0800","0.0800","0.0800","0.0800","0.0800","0.0900","0.0800","0.0800","0.0800","0.0900","0.0800","0.0800","0.0800","0.0800","0.0900","0.0700","0.0800","0.0800","0.0900","0.0900","0.0900","0.0800","0.0800","0.0900","0.0800","0.0800","0.0800","0.0800","0.0900","0.0800","0.0800","0.0800","0.0900","0.0900","0.0800","0.0800","0.0800","0.0800","0.0800","0.0800","0.0900","0.0800","0.0800","0.0800","0.0800","0.0800","0.0800","0.0800","0.0900","0.0800","0.0800","0.0800","0.0800","0.0800","0.0800","0.0800","0.0800","0.0800","0.0800","0.0800","0.0800","0.0800","0.0800","0.0800","0.0800","0.0800","0.0800","0.0800","0.0800","0.0800","0.0800","0.0800","0.0800","0.0800","0.0800","0.0700","0.0700","0.0900","0.0800","0.0700","0.0700","0.0700","0.0700","0.0700","0.1400","0.0700","0.0600","0.0600","0.1100","0.0600","0.0600","0.0600","0.1400","0.0600","0.0600","0.0700","0.1400","0.0600","0.0600","0.0600","0.0600","0.0600","0.0600","0.0600","0.0600","0.0600","0.0600","0.0600","0.0600","0.0600","0.0700","0.0700","0.1000","0.0600","0.0600","0.0700","0.0600","0.0700","0.0700","0.1200","0.0700","0.0700","0.0600","0.0700","0.0700","0.0600","0.0600","0.0600","0.0700","0.0600","0.0700","0.0600","0.0700","0.0700","0.0700","0.1000","0.0700","0.0700","0.0700","0.0700","0.0600","0.0600","0.0700","0.0700","0.0700","0.0600","0.0600","0.1200","0.1400","0.0700","0.0700","0.0700","0.0700","0.0700","0.0700","0.0700","0.0600","0.0600","0.0700","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-","-"]},
    aaa:[{
      "name": "韩店变",
      "config": {
        "columnlen": {
          "0": 68,
          "1": 194,
          "2": 203
        },
        "customWidth": {
          "0": 1,
          "1": 1,
          "2": 1,
          "3": 1,
          "4": 1,
          "5": 1,
          "6": 1,
          "7": 1,
          "8": 1,
          "9": 1,
          "10": 1,
          "11": 1,
          "12": 1,
          "13": 1,
          "14": 1
        },
        "colhidden": {
          "3": 0,
          "4": 0,
          "5": 0,
          "6": 0,
          "7": 0,
          "8": 0,
          "9": 0,
          "10": 0,
          "11": 0,
          "12": 0,
          "13": 0,
          "14": 0
        },
        "rowlen": {
          "0": 57,
          "3": 2,
          "4": 22,
          "6": 20,
          "7": 20,
          "9": 20,
          "10": 20,
          "11": 20,
          "12": 20,
          "13": 20,
          "14": 20,
          "15": 20,
          "16": 20,
          "17": 20,
          "18": 20,
          "19": 20,
          "20": 20,
          "21": 20,
          "22": 20,
          "23": 22
        },
        "customHeight": {
          "0": 1,
          "1": 1,
          "2": 1,
          "3": 1,
          "5": 1,
          "6": 1,
          "7": 1,
          "9": 1,
          "10": 1,
          "11": 1,
          "12": 1,
          "13": 1,
          "14": 1,
          "15": 1,
          "16": 1,
          "17": 1,
          "18": 1,
          "19": 1,
          "20": 1,
          "21": 1,
          "22": 1
        },
        "rowhidden": {
          "1": 0,
          "2": 0,
          "5": 0
        },
        "borderInfo": [{
          "rangeType": "cell",
          "value": {
            "row_index": 6,
            "col_index": 0,
            "l": {
              "style": 13,
              "color": "#000000"
            },
            "r": {
              "style": 1,
              "color": "#000000"
            },
            "t": {
              "style": 13,
              "color": "#000000"
            },
            "b": {
              "style": 1,
              "color": "#000000"
            }
          }
        }, {
          "rangeType": "cell",
          "value": {
            "row_index": 6,
            "col_index": 1,
            "l": {
              "style": 1,
              "color": "#000000"
            },
            "r": {
              "style": 1,
              "color": "#000000"
            },
            "t": {
              "style": 13,
              "color": "#000000"
            },
            "b": {
              "style": 1,
              "color": "#000000"
            }
          }
        }, {
          "rangeType": "cell",
          "value": {
            "row_index": 6,
            "col_index": 2,
            "l": {
              "style": 1,
              "color": "#000000"
            },
            "r": {
              "style": 1,
              "color": "#000000"
            },
            "t": {
              "style": 13,
              "color": "#000000"
            },
            "b": {
              "style": 1,
              "color": "#000000"
            }
          }
        }, {
          "rangeType": "cell",
          "value": {
            "row_index": 7,
            "col_index": 0,
            "l": {
              "style": 13,
              "color": "#000000"
            },
            "r": {
              "style": 1,
              "color": "#000000"
            },
            "t": {
              "style": 1,
              "color": "#000000"
            },
            "b": {
              "style": 1,
              "color": "#000000"
            }
          }
        }, {
          "rangeType": "cell",
          "value": {
            "row_index": 7,
            "col_index": 1,
            "l": {
              "style": 1,
              "color": "#000000"
            },
            "r": {
              "style": 1,
              "color": "#000000"
            },
            "t": {
              "style": 1,
              "color": "#000000"
            },
            "b": {
              "style": 1,
              "color": "#000000"
            }
          }
        }, {
          "rangeType": "cell",
          "value": {
            "row_index": 7,
            "col_index": 2,
            "l": {
              "style": 1,
              "color": "#000000"
            },
            "r": {
              "style": 1,
              "color": "#000000"
            },
            "t": {
              "style": 1,
              "color": "#000000"
            },
            "b": {
              "style": 1,
              "color": "#000000"
            }
          }
        }, {
          "rangeType": "cell",
          "value": {
            "row_index": 9,
            "col_index": 0,
            "l": {
              "style": 13,
              "color": "#000000"
            },
            "r": {
              "style": 1,
              "color": "#000000"
            },
            "t": {
              "style": 1,
              "color": "#000000"
            },
            "b": {
              "style": 1,
              "color": "#000000"
            }
          }
        }, {
          "rangeType": "cell",
          "value": {
            "row_index": 9,
            "col_index": 1,
            "l": {
              "style": 1,
              "color": "#000000"
            },
            "r": {
              "style": 1,
              "color": "#000000"
            },
            "t": {
              "style": 1,
              "color": "#000000"
            },
            "b": {
              "style": 1,
              "color": "#000000"
            }
          }
        }, {
          "rangeType": "cell",
          "value": {
            "row_index": 9,
            "col_index": 2,
            "l": {
              "style": 1,
              "color": "#000000"
            },
            "r": {
              "style": 1,
              "color": "#000000"
            },
            "t": {
              "style": 1,
              "color": "#000000"
            },
            "b": {
              "style": 1,
              "color": "#000000"
            }
          }
        }, {
          "rangeType": "cell",
          "value": {
            "row_index": 10,
            "col_index": 0,
            "l": {
              "style": 13,
              "color": "#000000"
            },
            "r": {
              "style": 1,
              "color": "#000000"
            },
            "t": {
              "style": 1,
              "color": "#000000"
            },
            "b": {
              "style": 1,
              "color": "#000000"
            }
          }
        }, {
          "rangeType": "cell",
          "value": {
            "row_index": 10,
            "col_index": 1,
            "l": {
              "style": 1,
              "color": "#000000"
            },
            "r": {
              "style": 1,
              "color": "#000000"
            },
            "t": {
              "style": 1,
              "color": "#000000"
            },
            "b": {
              "style": 1,
              "color": "#000000"
            }
          }
        }, {
          "rangeType": "cell",
          "value": {
            "row_index": 10,
            "col_index": 2,
            "l": {
              "style": 1,
              "color": "#000000"
            },
            "r": {
              "style": 1,
              "color": "#000000"
            },
            "t": {
              "style": 1,
              "color": "#000000"
            },
            "b": {
              "style": 1,
              "color": "#000000"
            }
          }
        }, {
          "rangeType": "cell",
          "value": {
            "row_index": 11,
            "col_index": 0,
            "l": {
              "style": 13,
              "color": "#000000"
            },
            "r": {
              "style": 1,
              "color": "#000000"
            },
            "t": {
              "style": 1,
              "color": "#000000"
            },
            "b": {
              "style": 1,
              "color": "#000000"
            }
          }
        }, {
          "rangeType": "cell",
          "value": {
            "row_index": 11,
            "col_index": 1,
            "l": {
              "style": 1,
              "color": "#000000"
            },
            "r": {
              "style": 1,
              "color": "#000000"
            },
            "t": {
              "style": 1,
              "color": "#000000"
            },
            "b": {
              "style": 1,
              "color": "#000000"
            }
          }
        }, {
          "rangeType": "cell",
          "value": {
            "row_index": 11,
            "col_index": 2,
            "l": {
              "style": 1,
              "color": "#000000"
            },
            "r": {
              "style": 1,
              "color": "#000000"
            },
            "t": {
              "style": 1,
              "color": "#000000"
            },
            "b": {
              "style": 1,
              "color": "#000000"
            }
          }
        }, {
          "rangeType": "cell",
          "value": {
            "row_index": 12,
            "col_index": 0,
            "l": {
              "style": 13,
              "color": "#000000"
            },
            "r": {
              "style": 1,
              "color": "#000000"
            },
            "t": {
              "style": 1,
              "color": "#000000"
            },
            "b": {
              "style": 1,
              "color": "#000000"
            }
          }
        }, {
          "rangeType": "cell",
          "value": {
            "row_index": 12,
            "col_index": 1,
            "l": {
              "style": 1,
              "color": "#000000"
            },
            "r": {
              "style": 1,
              "color": "#000000"
            },
            "t": {
              "style": 1,
              "color": "#000000"
            },
            "b": {
              "style": 1,
              "color": "#000000"
            }
          }
        }, {
          "rangeType": "cell",
          "value": {
            "row_index": 12,
            "col_index": 2,
            "l": {
              "style": 1,
              "color": "#000000"
            },
            "r": {
              "style": 1,
              "color": "#000000"
            },
            "t": {
              "style": 1,
              "color": "#000000"
            },
            "b": {
              "style": 1,
              "color": "#000000"
            }
          }
        }, {
          "rangeType": "cell",
          "value": {
            "row_index": 13,
            "col_index": 0,
            "l": {
              "style": 13,
              "color": "#000000"
            },
            "r": {
              "style": 1,
              "color": "#000000"
            },
            "t": {
              "style": 1,
              "color": "#000000"
            },
            "b": {
              "style": 1,
              "color": "#000000"
            }
          }
        }, {
          "rangeType": "cell",
          "value": {
            "row_index": 13,
            "col_index": 1,
            "l": {
              "style": 1,
              "color": "#000000"
            },
            "r": {
              "style": 1,
              "color": "#000000"
            },
            "t": {
              "style": 1,
              "color": "#000000"
            },
            "b": {
              "style": 1,
              "color": "#000000"
            }
          }
        }, {
          "rangeType": "cell",
          "value": {
            "row_index": 13,
            "col_index": 2,
            "l": {
              "style": 1,
              "color": "#000000"
            },
            "r": {
              "style": 1,
              "color": "#000000"
            },
            "t": {
              "style": 1,
              "color": "#000000"
            },
            "b": {
              "style": 1,
              "color": "#000000"
            }
          }
        }, {
          "rangeType": "cell",
          "value": {
            "row_index": 14,
            "col_index": 0,
            "l": {
              "style": 13,
              "color": "#000000"
            },
            "r": {
              "style": 1,
              "color": "#000000"
            },
            "t": {
              "style": 1,
              "color": "#000000"
            },
            "b": {
              "style": 1,
              "color": "#000000"
            }
          }
        }, {
          "rangeType": "cell",
          "value": {
            "row_index": 14,
            "col_index": 1,
            "l": {
              "style": 1,
              "color": "#000000"
            },
            "r": {
              "style": 1,
              "color": "#000000"
            },
            "t": {
              "style": 1,
              "color": "#000000"
            },
            "b": {
              "style": 1,
              "color": "#000000"
            }
          }
        }, {
          "rangeType": "cell",
          "value": {
            "row_index": 14,
            "col_index": 2,
            "l": {
              "style": 1,
              "color": "#000000"
            },
            "r": {
              "style": 1,
              "color": "#000000"
            },
            "t": {
              "style": 1,
              "color": "#000000"
            },
            "b": {
              "style": 1,
              "color": "#000000"
            }
          }
        }, {
          "rangeType": "cell",
          "value": {
            "row_index": 15,
            "col_index": 0,
            "l": {
              "style": 13,
              "color": "#000000"
            },
            "r": {
              "style": 1,
              "color": "#000000"
            },
            "t": {
              "style": 1,
              "color": "#000000"
            },
            "b": {
              "style": 1,
              "color": "#000000"
            }
          }
        }, {
          "rangeType": "cell",
          "value": {
            "row_index": 15,
            "col_index": 1,
            "l": {
              "style": 1,
              "color": "#000000"
            },
            "r": {
              "style": 1,
              "color": "#000000"
            },
            "t": {
              "style": 1,
              "color": "#000000"
            },
            "b": {
              "style": 1,
              "color": "#000000"
            }
          }
        }, {
          "rangeType": "cell",
          "value": {
            "row_index": 15,
            "col_index": 2,
            "l": {
              "style": 1,
              "color": "#000000"
            },
            "r": {
              "style": 1,
              "color": "#000000"
            },
            "t": {
              "style": 1,
              "color": "#000000"
            },
            "b": {
              "style": 1,
              "color": "#000000"
            }
          }
        }, {
          "rangeType": "cell",
          "value": {
            "row_index": 16,
            "col_index": 0,
            "l": {
              "style": 13,
              "color": "#000000"
            },
            "r": {
              "style": 1,
              "color": "#000000"
            },
            "t": {
              "style": 1,
              "color": "#000000"
            },
            "b": {
              "style": 1,
              "color": "#000000"
            }
          }
        }, {
          "rangeType": "cell",
          "value": {
            "row_index": 16,
            "col_index": 1,
            "l": {
              "style": 1,
              "color": "#000000"
            },
            "r": {
              "style": 1,
              "color": "#000000"
            },
            "t": {
              "style": 1,
              "color": "#000000"
            },
            "b": {
              "style": 1,
              "color": "#000000"
            }
          }
        }, {
          "rangeType": "cell",
          "value": {
            "row_index": 16,
            "col_index": 2,
            "l": {
              "style": 1,
              "color": "#000000"
            },
            "r": {
              "style": 1,
              "color": "#000000"
            },
            "t": {
              "style": 1,
              "color": "#000000"
            },
            "b": {
              "style": 1,
              "color": "#000000"
            }
          }
        }, {
          "rangeType": "cell",
          "value": {
            "row_index": 17,
            "col_index": 0,
            "l": {
              "style": 13,
              "color": "#000000"
            },
            "r": {
              "style": 1,
              "color": "#000000"
            },
            "t": {
              "style": 1,
              "color": "#000000"
            },
            "b": {
              "style": 1,
              "color": "#000000"
            }
          }
        }, {
          "rangeType": "cell",
          "value": {
            "row_index": 17,
            "col_index": 1,
            "l": {
              "style": 1,
              "color": "#000000"
            },
            "r": {
              "style": 1,
              "color": "#000000"
            },
            "t": {
              "style": 1,
              "color": "#000000"
            },
            "b": {
              "style": 1,
              "color": "#000000"
            }
          }
        }, {
          "rangeType": "cell",
          "value": {
            "row_index": 17,
            "col_index": 2,
            "l": {
              "style": 1,
              "color": "#000000"
            },
            "r": {
              "style": 1,
              "color": "#000000"
            },
            "t": {
              "style": 1,
              "color": "#000000"
            },
            "b": {
              "style": 1,
              "color": "#000000"
            }
          }
        }, {
          "rangeType": "cell",
          "value": {
            "row_index": 18,
            "col_index": 0,
            "l": {
              "style": 13,
              "color": "#000000"
            },
            "r": {
              "style": 1,
              "color": "#000000"
            },
            "t": {
              "style": 1,
              "color": "#000000"
            },
            "b": {
              "style": 1,
              "color": "#000000"
            }
          }
        }, {
          "rangeType": "cell",
          "value": {
            "row_index": 18,
            "col_index": 1,
            "l": {
              "style": 1,
              "color": "#000000"
            },
            "r": {
              "style": 1,
              "color": "#000000"
            },
            "t": {
              "style": 1,
              "color": "#000000"
            },
            "b": {
              "style": 1,
              "color": "#000000"
            }
          }
        }, {
          "rangeType": "cell",
          "value": {
            "row_index": 18,
            "col_index": 2,
            "l": {
              "style": 1,
              "color": "#000000"
            },
            "r": {
              "style": 1,
              "color": "#000000"
            },
            "t": {
              "style": 1,
              "color": "#000000"
            },
            "b": {
              "style": 1,
              "color": "#000000"
            }
          }
        }, {
          "rangeType": "cell",
          "value": {
            "row_index": 19,
            "col_index": 0,
            "l": {
              "style": 13,
              "color": "#000000"
            },
            "r": {
              "style": 1,
              "color": "#000000"
            },
            "t": {
              "style": 1,
              "color": "#000000"
            },
            "b": {
              "style": 1,
              "color": "#000000"
            }
          }
        }, {
          "rangeType": "cell",
          "value": {
            "row_index": 19,
            "col_index": 1,
            "l": {
              "style": 1,
              "color": "#000000"
            },
            "r": {
              "style": 1,
              "color": "#000000"
            },
            "t": {
              "style": 1,
              "color": "#000000"
            },
            "b": {
              "style": 1,
              "color": "#000000"
            }
          }
        }, {
          "rangeType": "cell",
          "value": {
            "row_index": 19,
            "col_index": 2,
            "l": {
              "style": 1,
              "color": "#000000"
            },
            "r": {
              "style": 1,
              "color": "#000000"
            },
            "t": {
              "style": 1,
              "color": "#000000"
            },
            "b": {
              "style": 1,
              "color": "#000000"
            }
          }
        }, {
          "rangeType": "cell",
          "value": {
            "row_index": 20,
            "col_index": 0,
            "l": {
              "style": 13,
              "color": "#000000"
            },
            "r": {
              "style": 1,
              "color": "#000000"
            },
            "t": {
              "style": 1,
              "color": "#000000"
            }
          }
        }, {
          "rangeType": "cell",
          "value": {
            "row_index": 20,
            "col_index": 1,
            "l": {
              "style": 1,
              "color": "#000000"
            },
            "r": {
              "style": 1,
              "color": "#000000"
            },
            "t": {
              "style": 1,
              "color": "#000000"
            }
          }
        }, {
          "rangeType": "cell",
          "value": {
            "row_index": 20,
            "col_index": 2,
            "l": {
              "style": 1,
              "color": "#000000"
            },
            "r": {
              "style": 1,
              "color": "#000000"
            },
            "t": {
              "style": 1,
              "color": "#000000"
            }
          }
        }, {
          "rangeType": "cell",
          "value": {
            "row_index": 21,
            "col_index": 0,
            "l": {
              "style": 8,
              "color": "#000000"
            },
            "r": {
              "style": 1,
              "color": "#000000"
            },
            "t": {
              "style": 1,
              "color": "#000000"
            },
            "b": {
              "style": 1,
              "color": "#000000"
            }
          }
        }, {
          "rangeType": "cell",
          "value": {
            "row_index": 21,
            "col_index": 1,
            "l": {
              "style": 1,
              "color": "#000000"
            },
            "r": {
              "style": 1,
              "color": "#000000"
            },
            "t": {
              "style": 1,
              "color": "#000000"
            },
            "b": {
              "style": 1,
              "color": "#000000"
            }
          }
        }, {
          "rangeType": "cell",
          "value": {
            "row_index": 21,
            "col_index": 2,
            "l": {
              "style": 1,
              "color": "#000000"
            },
            "r": {
              "style": 1,
              "color": "#000000"
            },
            "t": {
              "style": 1,
              "color": "#000000"
            },
            "b": {
              "style": 1,
              "color": "#000000"
            }
          }
        }, {
          "rangeType": "cell",
          "value": {
            "row_index": 22,
            "col_index": 0,
            "l": {
              "style": 8,
              "color": "#000000"
            },
            "r": {
              "style": 1,
              "color": "#000000"
            },
            "t": {
              "style": 1,
              "color": "#000000"
            },
            "b": {
              "style": 13,
              "color": "#000000"
            }
          }
        }, {
          "rangeType": "cell",
          "value": {
            "row_index": 22,
            "col_index": 1,
            "l": {
              "style": 1,
              "color": "#000000"
            },
            "r": {
              "style": 1,
              "color": "#000000"
            },
            "t": {
              "style": 1,
              "color": "#000000"
            },
            "b": {
              "style": 13,
              "color": "#000000"
            }
          }
        }, {
          "rangeType": "cell",
          "value": {
            "row_index": 22,
            "col_index": 2,
            "l": {
              "style": 1,
              "color": "#000000"
            },
            "r": {
              "style": 1,
              "color": "#000000"
            },
            "t": {
              "style": 1,
              "color": "#000000"
            },
            "b": {
              "style": 13,
              "color": "#000000"
            }
          }
        }],
        "merge": {
          "0_0": {
            "r": 0,
            "c": 0,
            "rs": 1,
            "cs": 14
          },
          "1_0": {
						"rs": 1,//合并多少行
						"cs": 14,//合并多少列
						"r": 1,
						"c": 0
					},
          "3_0": {
						"rs": 1,//合并多少行
						"cs": 1,//合并多少列
						"r": 3,
						"c": 0
					},
        }
        // "merge": {
        //   "0_3": {
        //     "r": 0,
        //     "c": 3,
        //     "rs": 1,
        //     "cs": 4
        //   },
        //   "6_0": {
        //     "r": 6,
        //     "c": 0,
        //     "rs": 2,
        //     "cs": 1
        //   },
        //   "6_1": {
        //     "r": 6,
        //     "c": 1,
        //     "rs": 1,
        //     "cs": 2
        //   },
        //   "0_0": {
        //     "r": 0,
        //     "c": 0,
        //     "rs": 1,
        //     "cs": 26
        //   },
        //   "4_0": {
        //     "r": 4,
        //     "c": 0,
        //     "rs": 1,
        //     "cs": 3
        //   }
        // }
      },
      "index": "1",
      "status": "1",
      "order": "0",
      "luckysheet_select_save": [{
        "row": [15, 15],
        "column": [19, 19],
        "sheetIndex": 1
      }],
      "zoomRatio": 0.8,
      "showGridLines": "1",
      "defaultColWidth": 72,
      "defaultRowHeight": 21,
      "celldata": [{
        "r": 0,
        "c": 0,
        "v": {
          "ct": {
            "fa": "General",
            "t": "s"
          }, 
          "fs": 26,
          "ff": "宋体",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "tb": 1,
          "v": "年报表",
          "qp": 1
        }
      }, {
        "r": 0,
        "c": 1,
        "v": {
          "ct": {
            "fa": "General"
          },
          "fs": 26,
          "ff": "宋体",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "tb": 1,
          "v": "年报表",
          "qp": 1
        }
      },  {
        "r": 0,
        "c": 3,
        "v": {
          "ct": {
            "fa": "General"
          },
          "fs": 26,
          "ff": "宋体",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "tb": 1
        }
      }, {
        "r": 0,
        "c": 4,
        "v": {
          "ct": {
            "fa": "General"
          },
          "fs": 26,
          "ff": "宋体",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "tb": 1
        }
      }, {
        "r": 0,
        "c": 5,
        "v": {
          "ct": {
            "fa": "General"
          },
          "fs": 26,
          "ff": "宋体",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "tb": 1
        }
      }, {
        "r": 0,
        "c": 6,
        "v": {
          "ct": {
            "fa": "General"
          },
          "fs": 26,
          "ff": "宋体",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "tb": 1
        }
      },{
        "r": 0,
        "c": 2,
        "v": {
          "ct": {
            "fa": "General"
          },
        //   "ps": {
        //     "left": null,
        //     "top": null,
        //     "width": null,
        //     "height": null,
        //     "value": "Hello,world!",
        //     "isshow": true
        //   },
          "fs": 26,
          "ff": "宋体",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "tb": 1
        }
      }, {
        "r": 1,
        "c": 0,
        "v": {
          "ct": {
            "fa": "General"
          },
          "fs": 26,
          "ff": "宋体",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "tb": 1
        }
      }, {
        "r": 1,
        "c": 1,
        "v": {
          "ct": {
            "fa": "General"
          },
          "fs": 26,
          "ff": "宋体",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "tb": 1
        }
      }, {
        "r": 1,
        "c": 2,
        "v": {
          "ct": {
            "fa": "General"
          },
          "fs": 26,
          "ff": "宋体",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "tb": 1
        }
      }, {
        "r": 1,
        "c": 3,
        "v": {
          "ct": {
            "fa": "General"
          },
          "fs": 26,
          "ff": "宋体",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "tb": 1
        }
      }, {
        "r": 1,
        "c": 4,
        "v": {
          "ct": {
            "fa": "General"
          },
          "fs": 26,
          "ff": "宋体",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "tb": 1
        }
      }, {
        "r": 1,
        "c": 5,
        "v": {
          "ct": {
            "fa": "General"
          },
          "fs": 26,
          "ff": "宋体",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "tb": 1
        }
      }, {
        "r": 1,
        "c": 6,
        "v": {
          "ct": {
            "fa": "General"
          },
          "fs": 26,
          "ff": "宋体",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "tb": 1
        }
      }, {
        "r": 1,
        "c": 7,
        "v": {
          "ct": {
            "fa": "General"
          },
          "fs": 26,
          "ff": "宋体",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "tb": 1
        }
      }, {
        "r": 1,
        "c": 8,
        "v": {
          "ct": {
            "fa": "General"
          },
          "fs": 26,
          "ff": "宋体",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "tb": 1
        }
      }, {
        "r": 1,
        "c": 9,
        "v": {
          "ct": {
            "fa": "General"
          },
          "fs": 26,
          "ff": "宋体",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "tb": 1
        }
      }, {
        "r": 1,
        "c": 10,
        "v": {
          "ct": {
            "fa": "General"
          },
          "fs": 26,
          "ff": "宋体",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "tb": 1
        }
      }, {
        "r": 1,
        "c": 11,
        "v": {
          "ct": {
            "fa": "General"
          },
          "fs": 26,
          "ff": "宋体",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "tb": 1
        }
      }, {
        "r": 1,
        "c": 12,
        "v": {
          "ct": {
            "fa": "General"
          },
          "fs": 26,
          "ff": "宋体",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "tb": 1
        }
      }, {
        "r": 2,
        "c": 0,
        "v": {
          "ct": {
            "fa": "General"
          },
          "fs": 26,
          "ff": "宋体",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "tb": 1
        }
      }, {
        "r": 2,
        "c": 1,
        "v": {
          "ct": {
            "fa": "General"
          },
          "fs": 26,
          "ff": "宋体",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "tb": 1
        }
      }, {
        "r": 2,
        "c": 2,
        "v": {
          "ct": {
            "fa": "General"
          },
          "fs": 26,
          "ff": "宋体",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "tb": 1
        }
      }, {
        "r": 2,
        "c": 3,
        "v": {
          "ct": {
            "fa": "General"
          },
          "fs": 26,
          "ff": "宋体",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "tb": 1
        }
      }, {
        "r": 2,
        "c": 4,
        "v": {
          "ct": {
            "fa": "General"
          },
          "fs": 26,
          "ff": "宋体",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "tb": 1
        }
      }, {
        "r": 2,
        "c": 5,
        "v": {
          "ct": {
            "fa": "General"
          },
          "fs": 26,
          "ff": "宋体",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "tb": 1
        }
      }, {
        "r": 2,
        "c": 6,
        "v": {
          "ct": {
            "fa": "General"
          },
          "fs": 26,
          "ff": "宋体",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "tb": 1
        }
      }, {
        "r": 2,
        "c": 7,
        "v": {
          "ct": {
            "fa": "General"
          },
          "fs": 26,
          "ff": "宋体",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "tb": 1
        }
      }, {
        "r": 2,
        "c": 8,
        "v": {
          "ct": {
            "fa": "General"
          },
          "fs": 26,
          "ff": "宋体",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "tb": 1
        }
      }, {
        "r": 2,
        "c": 9,
        "v": {
          "ct": {
            "fa": "General"
          },
          "fs": 26,
          "ff": "宋体",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "tb": 1
        }
      }, {
        "r": 2,
        "c": 10,
        "v": {
          "ct": {
            "fa": "General"
          },
          "fs": 26,
          "ff": "宋体",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "tb": 1
        }
      }, {
        "r": 2,
        "c": 11,
        "v": {
          "ct": {
            "fa": "General"
          },
          "fs": 26,
          "ff": "宋体",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "tb": 1
        }
      }, {
        "r": 2,
        "c": 12,
        "v": {
          "ct": {
            "fa": "General"
          },
          "fs": 26,
          "ff": "宋体",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "tb": 1
        }
      }, {
        "r": 3,
        "c": 0,
        "v": {
          "ct": {
            "fa": "General"
          },
          "fs": 26,
          "ff": "宋体",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "tb": 1
        }
      }, {
        "r": 3,
        "c": 1,
        "v": {
          "ct": {
            "fa": "General"
          },
          "fs": 26,
          "ff": "宋体",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "tb": 1
        }
      }, {
        "r": 3,
        "c": 2,
        "v": {
          "ct": {
            "fa": "General"
          },
          "fs": 26,
          "ff": "宋体",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "tb": 1
        }
      }, {
        "r": 3,
        "c": 3,
        "v": {
          "ct": {
            "fa": "General"
          },
          "fs": 26,
          "ff": "宋体",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "tb": 1
        }
      }, {
        "r": 3,
        "c": 4,
        "v": {
          "ct": {
            "fa": "General"
          },
          "fs": 26,
          "ff": "宋体",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "tb": 1
        }
      }, {
        "r": 3,
        "c": 5,
        "v": {
          "ct": {
            "fa": "General"
          },
          "fs": 26,
          "ff": "宋体",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "tb": 1
        }
      }, {
        "r": 3,
        "c": 6,
        "v": {
          "ct": {
            "fa": "General"
          },
          "fs": 26,
          "ff": "宋体",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "tb": 1
        }
      }, {
        "r": 3,
        "c": 7,
        "v": {
          "ct": {
            "fa": "General"
          },
          "fs": 26,
          "ff": "宋体",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "tb": 1
        }
      }, {
        "r": 3,
        "c": 8,
        "v": {
          "ct": {
            "fa": "General"
          },
          "fs": 26,
          "ff": "宋体",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "tb": 1
        }
      }, {
        "r": 3,
        "c": 9,
        "v": {
          "ct": {
            "fa": "General"
          },
          "fs": 26,
          "ff": "宋体",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "tb": 1
        }
      }, {
        "r": 3,
        "c": 10,
        "v": {
          "ct": {
            "fa": "General"
          },
          "fs": 26,
          "ff": "宋体",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "tb": 1
        }
      }, {
        "r": 3,
        "c": 11,
        "v": {
          "ct": {
            "fa": "General"
          },
          "fs": 26,
          "ff": "宋体",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "tb": 1
        }
      }, {
        "r": 3,
        "c": 12,
        "v": {
          "ct": {
            "fa": "General"
          },
          "fs": 26,
          "ff": "宋体",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "tb": 1
        }
      }, {
        "r": 4,
        "c": 0,
        "v": {
          "ct": {
            "fa": "General",
            "t": "s"
          },
          "fs": 12,
          "ff": "宋体",
          "tb": 1,
          "v": "2021年",
          "qp": 1
        }
      }, {
        "r": 4,
        "c": 1,
        "v": {
          "ct": {
            "fa": "General"
          },
          "fs": 12,
          "ff": "宋体",
          "tb": 1
        }
      }, {
        "r": 4,
        "c": 2,
        "v": {
          "ct": {
            "fa": "General"
          },
          "fs": 12,
          "ff": "宋体",
          "tb": 1
        }
      }, 
      {
        "r": 6,
        "c": 0,
        "v": {
          "ct": {
            "fa": "General",
            "t": "s"
          },
          "bg": "#FFCC00",
          "fs": 12,
          "ff": "宋体",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "tb": 1,
          "v": "时间",
          "qp": 1
        }
      }, {
        "r": 6,
        "c": 1,
        "v": {
          "ct": {
            "fa": "General",
            "t": "s"
          },
          "bg": "#33CCCC",
          "fs": 12,
          "ff": "仿宋_GB2312",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "tb": 1,
          "v": "动力车间",
          "qp": 1
        }
      }, {
        "r": 6,
        "c": 2,
        "v": {
          "ct": {
            "fa": "General"
          },
          "bg": "#33CCCC",
          "fs": 12,
          "ff": "仿宋_GB2312",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "tb": 1
        }
      }, {
        "r": 7,
        "c": 0,
        "v": {
          "ct": {
            "fa": "General"
          },
          "fs": 12,
          "ff": "宋体",
          "tb": 1
        }
      }, {
        "r": 7,
        "c": 1,
        "v": {
          "ct": {
            "fa": "General",
            "t": "s"
          },
          "bg": "#CCFFFF",
          "fs": 12,
          "ff": "宋体",
          "ht": 0,
          "vt": 0,
          "tb": 1,
          "v": "表值",
          "qp": 1
        }
      }, {
        "r": 7,
        "c": 2,
        "v": {
          "ct": {
            "fa": "General",
            "t": "s"
          },
          "bg": "#CCFFFF",
          "fs": 12,
          "ff": "宋体",
          "ht": 0,
          "vt": 0,
          "tb": 1,
          "v": "差值",
          "qp": 1
        }
      }, {
        "r": 8,
        "c": 2,
        "v": {
          "tb": 1,
          "v": "-",
          "qp": 1
        }
      }, {
        "r": 9,
        "c": 0,
        "v": {
          "ct": {
            "fa": "0"
          },
          "bg": "#FFCC00",
          "fs": 12,
          "fc": "#0000FF",
          "ff": "宋体",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "tb": 1,
          "v": "2"
        }
      }, {
        "r": 9,
        "c": 1,
        "v": {
          "ct": {
            "fa": "0.00_ "
          },
          "fs": 12,
          "ff": "宋体",
          "tb": 1
        }
      }, {
        "r": 9,
        "c": 2,
        "v": {
          "ct": {
            "fa": "0.00_ "
          },
          "fs": 12,
          "ff": "宋体",
          "tb": 1
        }
      }, {
        "r": 10,
        "c": 0,
        "v": {
          "ct": {
            "fa": "0"
          },
          "bg": "#FFCC00",
          "fs": 12,
          "fc": "#0000FF",
          "ff": "宋体",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "tb": 1,
          "v": "3"
        }
      }, {
        "r": 10,
        "c": 1,
        "v": {
          "ct": {
            "fa": "0.00_ "
          },
          "fs": 12,
          "ff": "宋体",
          "tb": 1
        }
      }, {
        "r": 10,
        "c": 2,
        "v": {
          "ct": {
            "fa": "0.00_ "
          },
          "fs": 12,
          "ff": "宋体",
          "tb": 1
        }
      }, {
        "r": 11,
        "c": 0,
        "v": {
          "ct": {
            "fa": "0"
          },
          "bg": "#FFCC00",
          "fs": 12,
          "fc": "#0000FF",
          "ff": "宋体",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "tb": 1,
          "v": "4"
        }
      }, {
        "r": 11,
        "c": 1,
        "v": {
          "ct": {
            "fa": "0.00_ "
          },
          "fs": 12,
          "ff": "宋体",
          "tb": 1
        }
      }, {
        "r": 11,
        "c": 2,
        "v": {
          "ct": {
            "fa": "0.00_ "
          },
          "fs": 12,
          "ff": "宋体",
          "tb": 1
        }
      }, {
        "r": 12,
        "c": 0,
        "v": {
          "ct": {
            "fa": "0"
          },
          "bg": "#FFCC00",
          "fs": 12,
          "fc": "#0000FF",
          "ff": "宋体",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "tb": 1,
          "v": "5"
        }
      }, {
        "r": 12,
        "c": 1,
        "v": {
          "ct": {
            "fa": "0.00_ "
          },
          "fs": 12,
          "ff": "宋体",
          "tb": 1
        }
      }, {
        "r": 12,
        "c": 2,
        "v": {
          "ct": {
            "fa": "0.00_ "
          },
          "fs": 12,
          "ff": "宋体",
          "tb": 1
        }
      }, {
        "r": 13,
        "c": 0,
        "v": {
          "ct": {
            "fa": "0"
          },
          "bg": "#FFCC00",
          "fs": 12,
          "fc": "#0000FF",
          "ff": "宋体",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "tb": 1,
          "v": "6"
        }
      }, {
        "r": 13,
        "c": 1,
        "v": {
          "ct": {
            "fa": "0.00_ "
          },
          "fs": 12,
          "ff": "宋体",
          "tb": 1
        }
      }, {
        "r": 13,
        "c": 2,
        "v": {
          "ct": {
            "fa": "0.00_ "
          },
          "fs": 12,
          "ff": "宋体",
          "tb": 1
        }
      }, {
        "r": 14,
        "c": 0,
        "v": {
          "ct": {
            "fa": "0"
          },
          "bg": "#FFCC00",
          "fs": 12,
          "fc": "#0000FF",
          "ff": "宋体",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "tb": 1,
          "v": "7"
        }
      }, {
        "r": 14,
        "c": 1,
        "v": {
          "ct": {
            "fa": "0.00_ "
          },
          "fs": 12,
          "ff": "宋体",
          "tb": 1
        }
      }, {
        "r": 14,
        "c": 2,
        "v": {
          "ct": {
            "fa": "0.00_ "
          },
          "fs": 12,
          "ff": "宋体",
          "tb": 1
        }
      }, {
        "r": 15,
        "c": 0,
        "v": {
          "ct": {
            "fa": "0"
          },
          "bg": "#FFCC00",
          "fs": 12,
          "fc": "#0000FF",
          "ff": "宋体",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "tb": 1,
          "v": "8"
        }
      }, {
        "r": 15,
        "c": 1,
        "v": {
          "ct": {
            "fa": "0.00_ "
          },
          "fs": 12,
          "ff": "宋体",
          "tb": 1
        }
      }, {
        "r": 15,
        "c": 2,
        "v": {
          "ct": {
            "fa": "0.00_ "
          },
          "fs": 12,
          "ff": "宋体",
          "tb": 1
        }
      }, {
        "r": 16,
        "c": 0,
        "v": {
          "ct": {
            "fa": "0"
          },
          "bg": "#FFCC00",
          "fs": 12,
          "fc": "#0000FF",
          "ff": "宋体",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "tb": 1,
          "v": "9"
        }
      }, {
        "r": 16,
        "c": 1,
        "v": {
          "ct": {
            "fa": "0.00_ "
          },
          "fs": 12,
          "ff": "宋体",
          "tb": 1
        }
      }, {
        "r": 16,
        "c": 2,
        "v": {
          "ct": {
            "fa": "0.00_ "
          },
          "fs": 12,
          "ff": "宋体",
          "tb": 1
        }
      }, {
        "r": 17,
        "c": 0,
        "v": {
          "ct": {
            "fa": "0"
          },
          "bg": "#FFCC00",
          "fs": 12,
          "fc": "#0000FF",
          "ff": "宋体",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "tb": 1,
          "v": "10"
        }
      }, {
        "r": 17,
        "c": 1,
        "v": {
          "ct": {
            "fa": "0.00_ "
          },
          "fs": 12,
          "ff": "宋体",
          "tb": 1
        }
      }, {
        "r": 17,
        "c": 2,
        "v": {
          "ct": {
            "fa": "0.00_ "
          },
          "fs": 12,
          "ff": "宋体",
          "tb": 1
        }
      }, {
        "r": 18,
        "c": 0,
        "v": {
          "ct": {
            "fa": "0"
          },
          "bg": "#FFCC00",
          "fs": 12,
          "fc": "#0000FF",
          "ff": "宋体",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "tb": 1,
          "v": "11"
        }
      }, {
        "r": 18,
        "c": 1,
        "v": {
          "ct": {
            "fa": "0.00_ "
          },
          "fs": 12,
          "ff": "宋体",
          "tb": 1
        }
      }, {
        "r": 18,
        "c": 2,
        "v": {
          "ct": {
            "fa": "0.00_ "
          },
          "fs": 12,
          "ff": "宋体",
          "tb": 1
        }
      }, {
        "r": 19,
        "c": 0,
        "v": {
          "ct": {
            "fa": "0"
          },
          "bg": "#FFCC00",
          "fs": 12,
          "fc": "#0000FF",
          "ff": "宋体",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "tb": 1,
          "v": "12"
        }
      }, {
        "r": 19,
        "c": 1,
        "v": {
          "ct": {
            "fa": "0.00_ "
          },
          "fs": 12,
          "ff": "宋体",
          "tb": 1
        }
      }, {
        "r": 19,
        "c": 2,
        "v": {
          "ct": {
            "fa": "0.00_ "
          },
          "fs": 12,
          "ff": "宋体",
          "tb": 1
        }
      }, {
        "r": 20,
        "c": 0,
        "v": {
          "ct": {
            "fa": "General",
            "t": "s"
          },
          "bg": "#FFCC00",
          "fs": 12,
          "fc": "#0000FF",
          "ff": "宋体",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "tb": 1,
          "v": "最大值",
          "qp": 1
        }
      }, {
        "r": 20,
        "c": 1,
        "v": {
          "f": "=MAX(B9:B20)",
          "ct": {
            "fa": "0.00_ "
          },
          "fs": 12,
          "ff": "宋体",
          "tb": 1,
          "v": "0"
        }
      }, {
        "r": 20,
        "c": 2,
        "v": {
          "f": "=MAX(C9:C20)",
          "ct": {
            "fa": "0.00_ "
          },
          "fs": 12,
          "ff": "宋体",
          "tb": 1,
          "v": "0"
        }
      }, {
        "r": 21,
        "c": 0,
        "v": {
          "ct": {
            "fa": "General",
            "t": "s"
          },
          "bg": "#FFCC00",
          "fs": 12,
          "fc": "#0000FF",
          "ff": "宋体",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "tb": 1,
          "v": "最小值",
          "qp": 1
        }
      }, {
        "r": 21,
        "c": 1,
        "v": {
          "f": "=MIN(B9:B20)",
          "ct": {
            "fa": "0.00_ "
          },
          "fs": 12,
          "ff": "宋体",
          "tb": 1,
          "v": "0"
        }
      }, {
        "r": 21,
        "c": 2,
        "v": {
          "f": "=MIN(C9:C20)",
          "ct": {
            "fa": "0.00_ "
          },
          "fs": 12,
          "ff": "宋体",
          "tb": 1,
          "v": "0"
        }
      }, {
        "r": 22,
        "c": 0,
        "v": {
          "ct": {
            "fa": "General",
            "t": "s"
          },
          "bg": "#FFCC00",
          "fs": 12,
          "fc": "#0000FF",
          "ff": "宋体",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "tb": 1,
          "v": "平均值",
          "qp": 1
        }
      }, {
        "r": 22,
        "c": 1,
        "v": {
          "f": "=AVERAGE(B9:B20)",
          "ct": {
            "fa": "0.00_ ",
            "t": "e"
          },
          "fs": 12,
          "ff": "宋体",
          "tb": 1,
          "v": "#DIV/0!"
        }
      }, {
        "r": 22,
        "c": 2,
        "v": {
          "f": "=AVERAGE(C9:C20)",
          "ct": {
            "fa": "0.00_ ",
            "t": "e"
          },
          "fs": 12,
          "ff": "宋体",
          "tb": 1,
          "v": "#DIV/0!"
        }
      }],
      
      
      "calcChain": [{
        "r": 20,
        "c": 1,
        "index": "1"
      }, {
        "r": 20,
        "c": 2,
        "index": "1"
      }, {
        "r": 21,
        "c": 1,
        "index": "1"
      }, {
        "r": 21,
        "c": 2,
        "index": "1"
      }, {
        "r": 22,
        "c": 1,
        "index": "1"
      }, {
        "r": 22,
        "c": 2,
        "index": "1"
      }, {
        "r": 20,
        "c": 1,
        "index": "1"
      }, {
        "r": 20,
        "c": 2,
        "index": "1"
      }, {
        "r": 21,
        "c": 1,
        "index": "1"
      }, {
        "r": 21,
        "c": 2,
        "index": "1"
      }, {
        "r": 22,
        "c": 1,
        "index": "1"
      }, {
        "r": 22,
        "c": 2,
        "index": "1"
      }]
    }],
    // r 行 
    // c 列
    ccc:[{
      "name":"测试1",
      "config": {
        //控制表格宽度
        "columnlen": {
          "0": 70,
          "1": 350,
          "2": 150,
          "3": 150,

        },
        //控制表格高度
        "rowlen": {
          "0": 40,
          "1": 20,
          "3": 20,
          "4": 20,
          "6": 20,
          "7": 20,
          "9": 20,
          "10": 20,
          "11": 20,
          "12": 20,
          "13": 20,
          "14": 20,
          "15": 20,
          "16": 20,
          "17": 20,
          "18": 20,
          "19": 20,
          "20": 20,
          "21": 20,
          "22": 20,
          "23": 22
        },
        //隐藏第几列
        "rowhidden": {
          // "1": 0,
          // "2": 0,
          // "5": 0
        },
        //表格样式(边框等)
       
        //合并单元格
        "merge": {
					"0_0": {
            "r": 0,
            "c": 0,
            "rs": 1,
            "cs": 14
          },
          "1_0": {
						"rs": 1,//合并多少行
						"cs": 14,//合并多少列
						"r": 1,
						"c": 0
					},
          "3_0": {
						"rs": 1,//合并多少行
						"cs": 1,//合并多少列
						"r": 3,
						"c": 0
					},
          
          
				},
          "customWidth": {
          "0": 1,
          "1": 1,
          "2": 1,
          "3": 1,
          "4": 1,
          "5": 1,
          "6": 1,
          "7": 1,
          "8": 1,
          "9": 1,
          "10": 1,
          "11": 1,
          "12": 1,
          "13": 1,
          "14": 1
        },
      },
      "index": "1",
      "status": "1",
      "order": "0",
      //默认选中
      "luckysheet_select_save": [{
        "row": [0, 0],
        "column": [0, 0],
        "sheetIndex": 1
      }],
      "celldata": [
        {
          "r": 0,
          "c": 0,
          "v": {
            "ct": {
              "fa": "General",
              "t": "s"
            }, 
            "fs": 24,
            "ff": "宋体",
            "bl": 1,
            "ht": 0,
            "vt": 0,
            "tb": 1,
            "v": "2022年报表 (全胜物业公司)",
            "qp": 1
          }
        },
       

    
        //第二行
      {
        "r": 1,
        "c": 0,
        "v": {
          "ct": {
            "fa": "General",
            
          },
          "fc": "#0000FF",
          "fs": 14,
          "ff": "宋体",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "v": "填报日期：2022-10-25  ",
          "tb": 1
        }
      }, 
      //第三行
      {
        "r": 2,
        "c": 0,
        "v": {
          "ct": {
            "fa": "General",
            "t": "s"
          },
          "bg": "#FFCC00",
          "fs": 12,
          "ff": "宋体",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "tb": 1,
          "v": "区域",
          "qp": 1
        }
      }, {
        "r": 2,
        "c": 1,
        "v": {
          "ct": {
            "fa": "General"
          },
          "fs": 14,
          "ff": "宋体",
          "bg": "#FFCC00",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "v": "设备名称",
          "tb": 1
        }
      }, {
        "r": 2,
        "c": 2,
        "v": {
          "ct": {
            "fa": "General"
          },
          "fs": 14,
          "ff": "宋体",
          "bg": "#FFCC00",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "v": "变量名",
          "tb": 1
        }
      }, {
        "r": 2,
        "c": 3,
        "v": {
          "ct": {
            "fa": "General"
          },
          "fs": 14,
          "ff": "宋体",
          "bg": "#FFCC00",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "v": "1月",
          "tb": 1
        }
      }, {
        "r": 2,
        "c": 4,
        "v": {
          "ct": {
            "fa": "General"
          },
          "fs": 14,
          "ff": "宋体",
           "bg": "#FFCC00",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "v": "2月",
          "tb": 1
        }
      }, {
        "r": 2,
        "c": 5,
        "v": {
          "ct": {
            "fa": "General"
          },
          "fs": 14,
          "ff": "宋体",
           "bg": "#FFCC00",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "v": "3月",
          "tb": 1
        }
      }, {
        "r": 2,
        "c": 6,
        "v": {
          "ct": {
            "fa": "General"
          },
          "fs": 14,
          "ff": "宋体",
           "bg": "#FFCC00",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "v": "4月",
          "tb": 1
        }
      }, {
        "r": 2,
        "c": 7,
        "v": {
          "ct": {
            "fa": "General"
          },
          "fs": 14,
          "ff": "宋体",
           "bg": "#FFCC00",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "v": "5月",
          "tb": 1
        }
      }, {
        "r": 2,
        "c": 8,
        "v": {
          "ct": {
            "fa": "General"
          },
          "fs": 14,
          "ff": "宋体",
           "bg": "#FFCC00",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "v": "6月",
          "tb": 1
        }
      }, {
        "r": 2,
        "c": 9,
        "v": {
          "ct": {
            "fa": "General"
          },
          "fs": 14,
          "ff": "宋体",
           "bg": "#FFCC00",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "v": "7月",
          "tb": 1
        }
      }, {
        "r": 2,
        "c": 10,
        "v": {
          "ct": {
            "fa": "General"
          },
          "fs": 14,
          "ff": "宋体",
           "bg": "#FFCC00",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "v": "八月",
          "tb": 1
        }
      }, {
        "r": 2,
        "c": 11,
        "v": {
          "ct": {
            "fa": "General"
          },
          "fs": 14,
          "ff": "宋体",
           "bg": "#FFCC00",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "v": "9月",
          "tb": 1
        }
      }, {
        "r": 2,
        "c": 12,
        "v": {
          "ct": {
            "fa": "General"
          },
          "fs": 14,
          "ff": "宋体",
           "bg": "#FFCC00",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "v": "10月",
          "tb": 1
        }
      }, 
      {
        "r": 2,
        "c": 13,
        "v": {
          "ct": {
            "fa": "General"
          },
          "fs": 14,
          "ff": "宋体",
           "bg": "#FFCC00",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "v": "11月",
          "tb": 1
        }
      },
      {
        "r": 2,
        "c": 14,
        "v": {
          "ct": {
            "fa": "General"
          },
          "fs": 14,
          "ff": "宋体",
           "bg": "#FFCC00",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "v": "12月",
          "tb": 1
        }
      },
      {
        "r": 2,
        "c": 15,
        "v": {
          "ct": {
            "fa": "General"
          },
          "fs": 15,
          "ff": "宋体",
           "bg": "#FFCC00",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "v": "最大值",
          "tb": 1
        }
      },
      {
        "r": 2,
        "c": 16,
        "v": {
          "ct": {
            "fa": "General"
          },
          "fs": 14,
          "ff": "宋体",
           "bg": "#FFCC00",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "v": "最小值",
          "tb": 1
        }
      },
      {
        "r": 2,
        "c": 17,
        "v": {
          "ct": {
            "fa": "General"
          },
          "fs": 14,
          "ff": "宋体",
           "bg": "#FFCC00",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "v": "平均值",
          "tb": 1
        }
      },
        //第四行
      {
        "r": 3,
        "c": 0,
        "v": {
          "ct": {
            "fa": "General"
          },
          "fs": 14,
          "ff": "宋体",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "v":"xx子公司1",
          "tb": 1
        }
      }, 
    
      {
        "r": 3,
        "c": 1,
        "v": {
          "ct": {
            "fa": "General"
          },
          "fs": 12,
          "ff": "宋体",
          "bl": 1,
          "ht": 0,
          "vt": 0,
          "v":"益大",
          "tb": 1
        }
      }
     ]
    }],
    ddd:[{
      "name": "Sheet1",
      "color": "",
      "status": "1",
      "order": "0",
      "config": {
        //控制表格宽度
        "columnlen": {
          "0": 70,
          "1": 150,
          "2": 150
        },
        //控制表格高度
        "rowlen": {
          "0": 40,
          "1": 20,
          "3": 20,
          "4": 20,
          "6": 20,
          "7": 20,
          "9": 20,
          "10": 20,
          "11": 20,
          "12": 20,
          "13": 20,
          "14": 20,
          "15": 20,
          "16": 20,
          "17": 20,
          "18": 20,
          "19": 20,
          "20": 20,
          "21": 20,
          "22": 20,
          "23": 22
        },
        //隐藏第几列
        "rowhidden": {
          // "1": 0,
          // "2": 0,
          // "5": 0
        },
        //表格样式(边框等)
        "borderInfo": [{
          "rangeType": "cell",
          "value": {
            "row_index": 2,
            "col_index": 0,
            "l": {
              "style": 13,
              "color": "#000000"
            },
            "r": {
              "style": 1,
              "color": "#000000"
            },
            "t": {
              "style": 1,
              "color": "#000000"
            },
            "b": {
              "style": 1,
              "color": "#000000"
            }
          }
        }, {
          "rangeType": "cell",
          "value": {
            "row_index": 2,
            "col_index": 1,
            "l": {
              "style": 1,
              "color": "#000000"
            },
            "r": {
              "style": 1,
              "color": "#000000"
            },
            "t": {
              "style": 1,
              "color": "#000000"
            },
            "b": {
              "style": 1,
              "color": "#000000"
            }
          }
        }, {
          "rangeType": "cell",
          "value": {
            "row_index": 2,
            "col_index": 2,
            "l": {
              "style": 1,
              "color": "#000000"
            },
            "r": {
              "style": 1,
              "color": "#000000"
            },
            "t": {
              "style": 1,
              "color": "#000000"
            },
            "b": {
              "style": 1,
              "color": "#000000"
            }
          }
        },{
          "rangeType": "cell",
          "value": {
            "row_index": 2,
            "col_index": 3,
            "l": {
              "style": 1,
              "color": "#000000"
            },
            "r": {
              "style": 1,
              "color": "#000000"
            },
            "t": {
              "style": 1,
              "color": "#000000"
            },
            "b": {
              "style": 1,
              "color": "#000000"
            }
          }
        },{
          "rangeType": "cell",
          "value": {
            "row_index": 2,
            "col_index": 4,
            "l": {
              "style": 1,
              "color": "#000000"
            },
            "r": {
              "style": 1,
              "color": "#000000"
            },
            "t": {
              "style": 1,
              "color": "#000000"
            },
            "b": {
              "style": 1,
              "color": "#000000"
            }
          }
        },{
          "rangeType": "cell",
          "value": {
            "row_index": 2,
            "col_index": 5,
            "l": {
              "style": 1,
              "color": "#000000"
            },
            "r": {
              "style": 1,
              "color": "#000000"
            },
            "t": {
              "style": 1,
              "color": "#000000"
            },
            "b": {
              "style": 1,
              "color": "#000000"
            }
          }
        },
        {
          "rangeType": "cell",
          "value": {
            "row_index": 2,
            "col_index": 6,
            "l": {
              "style": 1,
              "color": "#000000"
            },
            "r": {
              "style": 1,
              "color": "#000000"
            },
            "t": {
              "style": 1,
              "color": "#000000"
            },
            "b": {
              "style": 1,
              "color": "#000000"
            }
          }
        },{
          "rangeType": "cell",
          "value": {
            "row_index": 2,
            "col_index": 7,
            "l": {
              "style": 1,
              "color": "#000000"
            },
            "r": {
              "style": 1,
              "color": "#000000"
            },
            "t": {
              "style": 1,
              "color": "#000000"
            },
            "b": {
              "style": 1,
              "color": "#000000"
            }
          }
        },{
          "rangeType": "cell",
          "value": {
            "row_index": 2,
            "col_index": 8,
            "l": {
              "style": 1,
              "color": "#000000"
            },
            "r": {
              "style": 1,
              "color": "#000000"
            },
            "t": {
              "style": 1,
              "color": "#000000"
            },
            "b": {
              "style": 1,
              "color": "#000000"
            }
          }
        },{
          "rangeType": "cell",
          "value": {
            "row_index": 2,
            "col_index": 9,
            "l": {
              "style": 1,
              "color": "#000000"
            },
            "r": {
              "style": 1,
              "color": "#000000"
            },
            "t": {
              "style": 1,
              "color": "#000000"
            },
            "b": {
              "style": 1,
              "color": "#000000"
            }
          }
        },{
          "rangeType": "cell",
          "value": {
            "row_index": 2,
            "col_index": 10,
            "l": {
              "style": 1,
              "color": "#000000"
            },
            "r": {
              "style": 1,
              "color": "#000000"
            },
            "t": {
              "style": 1,
              "color": "#000000"
            },
            "b": {
              "style": 1,
              "color": "#000000"
            }
          }
        },
        {
          "rangeType": "cell",
          "value": {
            "row_index": 2,
            "col_index": 11,
            "l": {
              "style": 1,
              "color": "#000000"
            },
            "r": {
              "style": 1,
              "color": "#000000"
            },
            "t": {
              "style": 1,
              "color": "#000000"
            },
            "b": {
              "style": 1,
              "color": "#000000"
            }
          }
        },{
          "rangeType": "cell",
          "value": {
            "row_index": 2,
            "col_index": 12,
            "l": {
              "style": 1,
              "color": "#000000"
            },
            "r": {
              "style": 1,
              "color": "#000000"
            },
            "t": {
              "style": 1,
              "color": "#000000"
            },
            "b": {
              "style": 1,
              "color": "#000000"
            }
          }
        },{
          "rangeType": "cell",
          "value": {
            "row_index": 2,
            "col_index": 13,
            "l": {
              "style": 1,
              "color": "#000000"
            },
            "r": {
              "style": 1,
              "color": "#000000"
            },
            "t": {
              "style": 1,
              "color": "#000000"
            },
            "b": {
              "style": 1,
              "color": "#000000"
            }
          }
        },{
          "rangeType": "cell",
          "value": {
            "row_index": 2,
            "col_index": 14,
            "l": {
              "style": 1,
              "color": "#000000"
            },
            "r": {
              "style": 1,
              "color": "#000000"
            },
            "t": {
              "style": 1,
              "color": "#000000"
            },
            "b": {
              "style": 1,
              "color": "#000000"
            }
          }
        },{
          "rangeType": "cell",
          "value": {
            "row_index": 2,
            "col_index": 15,
            "l": {
              "style": 1,
              "color": "#000000"
            },
            "r": {
              "style": 1,
              "color": "#000000"
            },
            "t": {
              "style": 1,
              "color": "#000000"
            },
            "b": {
              "style": 1,
              "color": "#000000"
            }
          }
        },{
          "rangeType": "cell",
          "value": {
            "row_index": 2,
            "col_index": 16,
            "l": {
              "style": 1,
              "color": "#000000"
            },
            "r": {
              "style": 1,
              "color": "#000000"
            },
            "t": {
              "style": 1,
              "color": "#000000"
            },
            "b": {
              "style": 1,
              "color": "#000000"
            }
          }
        },{
          "rangeType": "cell",
          "value": {
            "row_index": 2,
            "col_index": 17,
            "l": {
              "style": 1,
              "color": "#000000"
            },
            "r": {
              "style": 1,
              "color": "#000000"
            },
            "t": {
              "style": 1,
              "color": "#000000"
            },
            "b": {
              "style": 1,
              "color": "#000000"
            }
          }
        }],
        //合并单元格
        "merge": {
					"0_0": {
            "r": 0,
            "c": 0,
            "rs": 1,
            "cs": 14
          },
          "1_0": {
						"rs": 1,//合并多少行
						"cs": 14,//合并多少列
						"r": 1,
						"c": 0
					},
          "3_0": {
						"rs": 1,//合并多少行
						"cs": 1,//合并多少列
						"r": 3,
						"c": 0
					},
          
          
				},
          "customWidth": {
          "0": 1,
          "1": 1,
          "2": 1,
          "3": 1,
          "4": 1,
          "5": 1,
          "6": 1,
          "7": 1,
          "8": 1,
          "9": 1,
          "10": 1,
          "11": 1,
          "12": 1,
          "13": 1,
          "14": 1
        },
      },
      "index": 0,
      "visibledatarow": [20, 40, 60, 80, 100, 120, 140, 160, 180, 200, 220, 240, 260, 280, 300, 320, 340, 360, 380, 400, 420, 440, 460, 480, 500, 520, 540, 560, 580, 600, 620, 640, 660, 680, 700, 720, 740, 760, 780, 800, 820, 840, 860, 880, 900, 920, 940, 960, 980, 1000, 1020, 1040, 1060, 1080, 1100, 1120, 1140, 1160, 1180, 1200, 1220, 1240, 1260, 1280, 1300, 1320, 1340, 1360, 1380, 1400, 1420, 1440, 1460, 1480, 1500, 1520, 1540, 1560, 1580, 1600, 1620, 1640, 1660, 1680, 1700, 1720, 1740, 1760, 1780, 1800, 1820, 1840, 1860, 1880, 1900, 1920, 1940, 1960, 1980, 2000],
      "visibledatacolumn": [74, 148, 222, 296, 370, 444, 518, 592, 666, 740, 814, 888, 962, 1036, 1110, 1184, 1258, 1332, 1406, 1480, 1554, 1628, 1702, 1776, 1850, 1924, 1998, 2072, 2146, 2220],
      "ch_width": 2340,
      "rh_height": 2080,
      "luckysheet_select_save": [{
        "row": [0, 0],
        "column": [0, 0],
        "row_focus": 0,
        "column_focus": 0,
        "left": 0,
        "width": 73,
        "top": 0,
        "height": 19,
        "left_move": 0,
        "width_move": 73,
        "top_move": 0,
        "height_move": 19
      }],
      "luckysheet_selection_range": [],
      "zoomRatio": 1,
     
    }]
  }

  const mutations = {
    modifyData(){
      console.log(state.ccc);
    }
  }
  

  

  
  export default {

    state,
    mutations

  }
  